<template>
  <vx-card
    title="Information"
    class="mt-base"
  >
    <h6 class="fs-1 mb-1">Name</h6>
    <vs-input
      class="w-full"
      v-model="data.name"
    />

    <h6 class="fs-1 mt-3">Title</h6>
    <vs-input
      class="w-full"
      label="Title ID"
      v-model="data.titleId"
    />

    <vs-input
      class="w-full mt-3"
      label="Title EN"
      v-model="data.titleEn"
    />

    <h6 class="fs-1 mb-2 mt-5">Short Description</h6>
    <vs-textarea rows="6" label="Short Description ID" v-model="data.excerptId"/>
    <vs-textarea rows="6" label="Short Description EN" v-model="data.excerptEn"/>

  </vx-card>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
